import React, { useContext,useState } from 'react'
import styled from 'styled-components';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Input from '../Input'
import Select from '../Select';
import { CategorysContext } from '../../context/categorys';

import { toast } from 'react-toastify';

const CardInput = styled.section`

    display: flex;
    flex-direction: column;
    width: 90%;
    margin: 0 auto;
    margin-bottom: 0.9em;


    input,select{
        width: 100%;
        height: 50px;
        margin-bottom: 0.9rem;
        border-radius: 10px;
    }

    div > label{
        font-size: 0.9rem;
    }

    .textPrimary{
        color: black;
        font-family: "Poppins";
        font-weight: 500;
        margin-bottom: 0rem;
        font-size: 1.1rem;
    }

    div{
        margin-left:0rem;
    }

    @media screen and (max-width:720px){
        flex-direction: column;

        div{
            margin-left: 0rem;
        }

    }


`
const CardWrapper = styled.section`
    display: flex;
    flex-direction: column;

`
const ImagePreview = styled.div`
    cursor: pointer;

    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    width: 155px;
    height: 155px;
    margin: 0 auto;
    object-fit: contain;
    border-radius: 100px;
    border: 2px solid #dddddd;

    img{
        width: 110px;
        height: 110px;
        object-fit: contain;
    }

`
const ChangeImageIcon = styled.div`
    position: absolute;
    display: flex;
    right: 0;
    bottom:0;
    justify-content: center;
    align-items: center;
    width: 40px;
    height:40px;
    border-radius: 100px;
    background-color: black;

`

const ModalEditSubCategorys = ({ props }) => {

    const [categoryName,setCategoryName] = useState()
    const [imagePreview,setImagereview] = useState()
    const [imageFirebase,setImageFirebase] = useState()
    const [categoryEdit,setCategoryEdit] = useState()
    const [subCategoryEdit,setSubCategoryEdit] = useState()

    const {
        storage,
        modalEditImage,
        categorys,
        modalEditName,
        subCategorys,
        subCategoryName,
        edit,
        updateSubCategory
    } = useContext(CategorysContext)


    const handleAddClick = () => {
        storage(categoryName)
        props.onHide(); // Fechar a modal após adicionar
    }
    const handleImage = (file) => {
    
            if (file) {
    
                const { type } = file
    
                const supportedTypes = ["image/png", "image/jpg", "image/jpeg"]
                const verifySupportedType = supportedTypes.includes(type)
    
    
                if (!verifySupportedType) {
                    return toast.error("Formato de imagem não suportado!")
                }
    
                const reader = new FileReader()
                reader.readAsDataURL(file)
                reader.onload = async () => {
    
                    setImagereview(reader.result)
                    setImageFirebase( file)
                }
    
            }
    
    }

    const handleEdit = () => {
        props.onHide()
        updateSubCategory("category",categoryEdit)
        updateSubCategory("name",subCategoryEdit)
        if(imageFirebase){
            updateSubCategory("image",imageFirebase)

        }
    }

    return (
        
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered

        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Editar
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <CardWrapper>
                    <label htmlFor="input_file">
                    <ImagePreview >
                    {imagePreview 
                    
                    ?
                    <img src={`data:image/;base64;${imagePreview}`}/>                
                    :
                    <img src={modalEditImage}/>

                    }
                    <ChangeImageIcon>
                    <svg width="27" height="27" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.7496 4.46524C12.3248 4.46524 11.9348 4.22314 11.7398 3.84961L11.2384 2.84662C10.918 2.21716 10.0823 1.69837 9.37196 1.69837H7.77715C7.05984 1.69837 6.22413 2.21716 5.90377 2.84662L5.40235 3.84961C5.20735 4.22314 4.81735 4.46524 4.39254 4.46524C2.8813 4.46524 1.68345 5.73108 1.78095 7.22518L2.14309 12.9388C2.22666 14.3637 2.99969 15.5327 4.92182 15.5327H12.2203C14.1425 15.5327 14.9085 14.3637 14.9991 12.9388L15.3612 7.22518C15.4587 5.73108 14.2609 4.46524 12.7496 4.46524ZM7.52644 5.32988H9.61571C9.90124 5.32988 10.138 5.56506 10.138 5.84867C10.138 6.13227 9.90124 6.36745 9.61571 6.36745H7.52644C7.24091 6.36745 7.00412 6.13227 7.00412 5.84867C7.00412 5.56506 7.24091 5.32988 7.52644 5.32988ZM8.57108 12.8488C7.27573 12.8488 6.21716 11.8043 6.21716 10.5108C6.21716 9.21732 7.26876 8.17283 8.57108 8.17283C9.87339 8.17283 10.925 9.21732 10.925 10.5108C10.925 11.8043 9.86642 12.8488 8.57108 12.8488Z" fill="white"/>
                    </svg>
                    </ChangeImageIcon>

                    </ImagePreview>
                    </label>

                    <CardInput>
                        <Select name={"Categoria *"} editValue={modalEditName} data={categorys} onChange={(e) => setCategoryEdit(e.target.value)}  target={"name"}  />
                        <Input name={"Sub Categoria *"} value={subCategoryName}  onChange={(e) => setSubCategoryEdit(e.target.value)}  />
                    </CardInput>
                </CardWrapper>

                <input id="input_file" name="input_file" onChange={(e) => handleImage(e.target.files[0])} type="file" style={{display:"none"}}/>

            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => handleEdit()}>Editar</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ModalEditSubCategorys